'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const PREVIEW_LOCAL_DELIVERY_ORDER_PLACED = 'PREVIEW_LOCAL_DELIVERY_ORDER_PLACED';
const PREVIEW_LOCAL_DELIVERY_PICKUP_IN_PROGRESS = 'PREVIEW_LOCAL_DELIVERY_PICKUP_IN_PROGRESS';
const PREVIEW_LOCAL_DELIVERY_ON_ITS_WAY = 'PREVIEW_LOCAL_DELIVERY_ON_ITS_WAY';
const PREVIEW_LOCAL_DELIVERY_DELIVERED = 'PREVIEW_LOCAL_DELIVERY_DELIVERED';
const PREVIEW_LOCAL_DELIVERY_EXCEPTION = 'PREVIEW_LOCAL_DELIVERY_EXCEPTION';
const PREVIEW_HPU_SCHEDULED = 'PREVIEW_HPU_SCHEDULED';
const PREVIEW_HPU_PICKUP_IN_PROGRESS = 'PREVIEW_HPU_PICKUP_IN_PROGRESS';
const PREVIEW_HPU_PICKED_UP = 'PREVIEW_HPU_PICKED_UP';
const PREVIEW_MAPVIEW_ON_ITS_WAY = 'PREVIEW_MAPVIEW_ON_ITS_WAY';
const PREVIEW_MAPVIEW_DELIVERED = 'PREVIEW_MAPVIEW_DELIVERED';
const getSteps = statusCode => ({
  PREVIEW_LOCAL_DELIVERY_ORDER_PLACED: {
    activeStep: 0,
    partialFill: true,
    partialWidth: '25%'
  },
  PREVIEW_LOCAL_DELIVERY_PICKUP_IN_PROGRESS: {
    activeStep: 1,
    partialFill: true,
    partialWidth: statusCode === 'SHPD_SDD_201' ? '45%' : '80%'
  },
  PREVIEW_LOCAL_DELIVERY_ON_ITS_WAY: {
    activeStep: 2,
    partialFill: true,
    partialWidth: '50%'
  },
  PREVIEW_LOCAL_DELIVERY_DELIVERED: {
    activeStep: 3
  },
  PREVIEW_LOCAL_DELIVERY_EXCEPTION: {
    activeStep: -1,
    exception: true
  },
  PREVIEW_HPU_SCHEDULED: {
    activeStep: 0,
    partialFill: true,
    partialWidth: '50%'
  },
  PREVIEW_HPU_PICKUP_IN_PROGRESS: {
    activeStep: 1,
    partialFill: true,
    partialWidth: '50%'
  },
  PREVIEW_HPU_PICKED_UP: {
    activeStep: 2
  },
  PREVIEW_HPU_EXCEPTION: {
    activeStep: -1,
    exception: true
  },
  PREVIEW_MAPVIEW_ON_ITS_WAY: {
    activeStep: 0,
    partialFill: true,
    partialWidth: '50%'
  },
  PREVIEW_MAPVIEW_DELIVERED: {
    activeStep: 1
  },
  PREVIEW_MAPVIEW_EXCEPTION: {
    activeStep: -1,
    exception: true
  }
});

exports.PREVIEW_HPU_PICKED_UP = PREVIEW_HPU_PICKED_UP;
exports.PREVIEW_HPU_PICKUP_IN_PROGRESS = PREVIEW_HPU_PICKUP_IN_PROGRESS;
exports.PREVIEW_HPU_SCHEDULED = PREVIEW_HPU_SCHEDULED;
exports.PREVIEW_LOCAL_DELIVERY_DELIVERED = PREVIEW_LOCAL_DELIVERY_DELIVERED;
exports.PREVIEW_LOCAL_DELIVERY_EXCEPTION = PREVIEW_LOCAL_DELIVERY_EXCEPTION;
exports.PREVIEW_LOCAL_DELIVERY_ON_ITS_WAY = PREVIEW_LOCAL_DELIVERY_ON_ITS_WAY;
exports.PREVIEW_LOCAL_DELIVERY_ORDER_PLACED = PREVIEW_LOCAL_DELIVERY_ORDER_PLACED;
exports.PREVIEW_LOCAL_DELIVERY_PICKUP_IN_PROGRESS = PREVIEW_LOCAL_DELIVERY_PICKUP_IN_PROGRESS;
exports.PREVIEW_MAPVIEW_DELIVERED = PREVIEW_MAPVIEW_DELIVERED;
exports.PREVIEW_MAPVIEW_ON_ITS_WAY = PREVIEW_MAPVIEW_ON_ITS_WAY;
exports.getSteps = getSteps;
